import { translate } from '@jsverse/transloco';
export enum AssetTypes {
    NETWORK = 'NETWORK',
    HOST = 'HOST',
    APPLICATION = 'APPLICATION',
    USER = 'USER',
    ENDPOINT = 'ENDPOINT',
    UTM = 'UTM',
    SITE = 'SITE',
    WEB_APPLICATION = 'WEB_APPLICATION',
    INTERNET = 'INTERNET',
}

export class AssetTypesHelper {
    static getAssetTypeLocale(assetType: AssetTypes): string {
        switch (assetType) {
            case AssetTypes.NETWORK:
                return translate('CORE.ASSET_TYPES.NETWORK');
            case AssetTypes.HOST:
                return translate('CORE.ASSET_TYPES.HOST');
            case AssetTypes.APPLICATION:
                return translate('CORE.ASSET_TYPES.APPLICATION');
            case AssetTypes.USER:
                return translate('CORE.ASSET_TYPES.USER');
            case AssetTypes.ENDPOINT:
                return translate('CORE.ASSET_TYPES.ENDPOINT');
            case AssetTypes.UTM:
                return translate('CORE.ASSET_TYPES.UTM');
            case AssetTypes.SITE:
                return translate('CORE.ASSET_TYPES.SITE');
            case AssetTypes.WEB_APPLICATION:
                return translate('CORE.ASSET_TYPES.WEB_APPLICATION');
            case AssetTypes.INTERNET:
                return translate('CORE.ASSET_TYPES.INTERNET');
            default:
                return assetType;
        }
    }

    static getAssetTypeIcon(assetType: AssetTypes): string {
        switch (assetType) {
            case AssetTypes.NETWORK:
                return 'rss_feed';
            case AssetTypes.HOST:
                return 'home';
            case AssetTypes.APPLICATION:
                return 'wysiwyg';
            case AssetTypes.USER:
                return 'person';
            case AssetTypes.ENDPOINT:
                return 'desktop_windows';
            case AssetTypes.INTERNET:
                return 'language';
            case AssetTypes.UTM:
                return 'rss_feed';
            default:
                return '';
        }
    }

    static getAssetTypeIconColor(assetType: AssetTypes): string {
        switch (assetType) {
            case AssetTypes.HOST:
                return 'var(--text-primary)';
            case AssetTypes.APPLICATION:
                return 'var(--success-text-color)';
            case AssetTypes.USER:
                return 'var(--warning-color)';
            case AssetTypes.ENDPOINT:
                return 'var(--text-primary)';
            case AssetTypes.INTERNET:
                return 'var(--success-text-color)';
            case AssetTypes.UTM:
                return 'var(--button-icon-primary-color)';
            default:
                return 'var(--button-icon-primary-color)';
        }
    }
}
